define([
	"dojo/_base/declare",
	"csi/view/ToolbarPluginMenu"
], function(declare,ToolbarPluginMenu) {

	return declare(ToolbarPluginMenu, {
		validatePlugin: function(/*Context*/ctx) {
			// summary: only allow if Sample BOM
			var	master = ctx.getNodeParent(ctx.getParent(), true);
			return master ? master.IsSampleBOM : this.inherited(arguments);
		}
	});
});